/**
 * API Clients Configuration
 *
 * Este archivo configura y exporta todas las instancias de axios
 * con sus respectivos interceptores.
 *
 * Estructura:
 * - config/clients.js: Instancias de axios
 * - config/interceptors.js: Interceptores de request
 * - config/tokenRefresh.js: Lógica de refresh de token (401)
 */

import {
  aludraApi,
  algoliaApi,
  busApi,
  documentBusApi,
  cuartApi,
  oaApi,
} from './config/clients'

import {
  setupAludraInterceptor,
  setupAlgoliaInterceptor,
  setupBusInterceptor,
  setupCuartInterceptor,
  setupOaInterceptor,
} from './config/interceptors'

import { setupTokenRefreshInterceptor } from './config/tokenRefresh'

// Configurar interceptores de request
setupAludraInterceptor(aludraApi)
setupAlgoliaInterceptor(algoliaApi)
setupBusInterceptor(busApi)
setupCuartInterceptor(cuartApi)
setupOaInterceptor(oaApi)

// Configurar interceptores de response (token refresh) para APIs con autenticación
const apisWithAuth = [aludraApi, algoliaApi, busApi, documentBusApi, cuartApi]
apisWithAuth.forEach(setupTokenRefreshInterceptor)

// Re-exportar todas las instancias
export { aludraApi, algoliaApi, busApi, documentBusApi, cuartApi, oaApi }
